/**
 * 新增 or 编辑
 */
import React, {
  useEffect,
  useReducer,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from 'react'
import { STriggerModal } from 'shj-components'
import { Form, Button, Select, Row, Col, message, Input } from 'antd'
import { ticketsBack } from '@/services/homeService'
import { getUser } from '@/common/utils'

const { Option } = Select
const { TextArea } = Input

interface IAddOrEditProps {
  reload?: (values: object) => void
  onClose?: (values: object) => void
  param?: object
  open?: boolean
}

const backPage: FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const { param, open, reload, onClose } = props
  const [form]: any = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState<Boolean>(false)
  const { setFieldsValue }: any = form

  useEffect(() => {
    const userInfo = getUser()

  }, [])

  // 提交
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const newValues = { ...values }
      newValues.id = param.id
      const userInfo = getUser()
      newValues.backUser = userInfo.workerNumber
      setSubmitLoading(true)
      ticketsBack(newValues)
        .then((resp: any) => {
          setSubmitLoading(false)
          message.info('操作成功')
          onClose?.()
          reload?.()
        })
        .catch(() => {
          setSubmitLoading(false)
        })
    })
  }

  return (
    <STriggerModal
      title={'退回'}
      open={open}
      cancel={true}
      okText="保存"
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
      reset={false}
      onReset={() => {
        form.resetFields()
      }}
      destroyOnClose
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item label="分类" name="backClassifyId" rules={[{ required: true, message: '请选择' }]}>
          <Select placeholder="请选择" allowClear>
            <Option key={'1'} value={'1'}>
              责任归属错误
            </Option>
            <Option key={'2'} value={'2'}>
              其他
            </Option>
          </Select>
        </Form.Item>

        <Form.Item label="原因描述" name="backDescription" rules={[{ required: true, message: '请输入' }]}>
          <TextArea placeholder="请输入" rows={2} />
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default backPage
